export default "__VITE_ASSET__gw5plNuE__"